import { render, staticRenderFns } from "./ViewEventPost.vue?vue&type=template&id=5d3ad764"
import script from "./ViewEventPost.vue?vue&type=script&lang=js"
export * from "./ViewEventPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports